import React from 'react';
import { CustomDatePicker } from '../../widgets/CustomDatePicker';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';



const utils = new ViewUtils();
export const ProviderModeratorModerationEndDateForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);

    return (
        <EntityForm ref={ref} viewId="ProviderModeratorModerationEndDateForm"
            dataURL={utils.isNull(props.dataURL) ? "" : props.dataURL}
            values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="ProviderModeratorModerationEndDateForm">
                    <table cellPadding="2" width="100%">
                        <tbody>
                            <tr>
                                <td>
                                    <CustomDatePicker
                                        id="ModerationEndDate"
                                        key={tabValue}
                                        label="Moderation End Date"
                                        className='{classes.textField} w-100'
                                        form={form}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </form>
            }
        </EntityForm>
    );
})
